import { Controller } from '@hotwired/stimulus'
import IMask from 'imask'

export default class extends Controller {
  connect() {
    this.patternMask = IMask(this.element, {
      mask: '+{1} (000) 000-0000',
      //Use to show mask when the component loads with data in it. Usually when an error occurs
      lazy: !this.element.value
    })

    //when you click on input, placeholders are shown
    this.element.addEventListener('focus', this.onFocus, true)
    //when click off, hide placeholders if input is empty
    this.element.addEventListener('blur', this.onBlur, true)
    this.element.addEventListener('change', this.onChange, true)

    document.addEventListener('turbo:morph', this.updateMaskValue)
    document.addEventListener('turbo:load', this.updateControl)
  }

  disconnect() {
    this.element.removeEventListener('focus', this.onFocus, true)
    this.element.removeEventListener('blur', this.onBlur, true)
    this.element.removeEventListener('change', this.onChange, true)

    document.removeEventListener('turbo:morph', this.updateControl)
    document.removeEventListener('turbo:load', this.updateControl)
  }

  onFocus = () => {
    this.valueOnFocus = this.patternMask.unmaskedValue
    this.changeFired = false
    this.patternMask.updateOptions({ lazy: false })
  }

  onChange = () => {
    this.changeFired = true
  }

  onBlur = () => {
    if (this.patternMask.unmaskedValue.length === 1) {
      this.patternMask.updateOptions({ lazy: true })
      this.patternMask.value = ''
    }

    // IMask intercepts keystrokes and sets the input's .value via JavaScript
    // rather than letting the browser handle input natively. Safari doesn't
    // fire a native change event when .value is set this way. Chrome/Brave do,
    // so we only dispatch manually when the browser didn't fire one itself.
    if (!this.changeFired && this.patternMask.unmaskedValue !== this.valueOnFocus) {
      this.element.dispatchEvent(new Event('change', { bubbles: true }))
    }
  }

  // Update the masked input when the page is loaded
  updateControl = () => {
    this.patternMask.updateControl()
  }

  // Update the masked input when the element is morphed
  updateMaskValue = () => {
    this.patternMask.updateValue()
  }
}
